var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import '@shoelace-style/shoelace/dist/components/input/input.js';
import { html } from 'lit';
import { property, state } from 'lit/decorators.js';
import { ifDefined } from 'lit/directives/if-defined.js';
import { when } from 'lit/directives/when.js';
import { v4 as uuidv4 } from 'uuid';
import { SgdfElement } from '../../internal/sgdf-element.js';
import { watch } from '../../internal/watch.js';
import styles from './debounced-input.styles.js';
/**
 * @summary Debounced input.
 * @status experimental
 * @since 1.0
 *
 * @dependency sl-input
 *
 * @event sgdf-debounced-input - Emitted on change after debounce.
 *
 * @csspart base - The component's base wrapper.
 * */
class SgdfDebouncedInput extends SgdfElement {
    constructor() {
        super(...arguments);
        this.initialValue = '';
        this.debounce = 500;
        this.value = '';
        this.listId = uuidv4();
        this.timeout = null;
    }
    connectedCallback() {
        super.connectedCallback();
        this.value = this.initialValue;
    }
    disconnectedCallback() {
        super.disconnectedCallback();
        if (this.timeout) {
            clearTimeout(this.timeout);
        }
    }
    handleValue() {
        this.timeout = setTimeout(() => {
            this.emit('sgdf-debounced-input', {
                detail: this.value,
            });
        }, this.debounce);
    }
    render() {
        return html `
        ${when(this.list && this.list.length > 0, () => html `<datalist id=${this.listId}>
                    ${this.list.slice(0, 5000).map((value) => html `<option value=${value} key=${value}></option>`)}
                </datalist>`)}

        <input
            placeholder=${ifDefined(this.placeholder)}
            clearable=${ifDefined(this.clearable)}
            type=${ifDefined(this.type)}
            min=${ifDefined(this.min)}
            max=${ifDefined(this.max)}
            value=${this.value}
            list=${ifDefined(this.list && this.list.length > 0 ? this.listId : undefined)}
            @click=${(event) => {
            event.preventDefault();
        }}
            @change=${(event) => {
            this.value = event.target.value;
        }}
        >
            ${when(this.icon, () => html `<sgdf-icon
                        name=${this.icon}
                        slot="prefix"
                    ></sgdf-icon>`)}
        </input>`;
    }
}
SgdfDebouncedInput.styles = styles;
export default SgdfDebouncedInput;
__decorate([
    property({ type: String, reflect: true })
], SgdfDebouncedInput.prototype, "initialValue", void 0);
__decorate([
    property({ type: String, reflect: true })
], SgdfDebouncedInput.prototype, "placeholder", void 0);
__decorate([
    property({ type: Boolean, reflect: true })
], SgdfDebouncedInput.prototype, "clearable", void 0);
__decorate([
    property({ type: String, reflect: true })
], SgdfDebouncedInput.prototype, "type", void 0);
__decorate([
    property({ type: Number, reflect: true })
], SgdfDebouncedInput.prototype, "min", void 0);
__decorate([
    property({ type: Number, reflect: true })
], SgdfDebouncedInput.prototype, "max", void 0);
__decorate([
    property({ type: Array, reflect: true })
], SgdfDebouncedInput.prototype, "list", void 0);
__decorate([
    property({ type: String, reflect: true })
], SgdfDebouncedInput.prototype, "icon", void 0);
__decorate([
    property({ type: Number, reflect: true })
], SgdfDebouncedInput.prototype, "debounce", void 0);
__decorate([
    state()
], SgdfDebouncedInput.prototype, "value", void 0);
__decorate([
    watch('value')
], SgdfDebouncedInput.prototype, "handleValue", null);
//# sourceMappingURL=debounced-input.component.js.map